import { SubmitTicket } from '@superbet-group/web.types';

import IBetSlip from '@models/betSlip/IBetSlip';
import { BetSlipType } from '@models/shared/betSlip/betSlipEnums';

import { transformBetslipSystemCombinations } from './transformBetslipSystemCombinations';
import { transformSelectionToTicketItem } from './transformSelectionToTicketItem';
import { getConfig } from '@superbet-group/web.lib.config';
import { ldAnonymousUserKey } from '@src/app/shared/featureFlags/initializeFeatureFlagMultiContext';
import { getDeviceId } from '@src/config/idGenerationService';
import {
    getIsDeviceIdEnabledInitial,
    getIsDeviceIdEnabledSubscribed,
} from '@app/shared/featureFlags/isEnabledByDeviceIdTest';

/* used to map the betslip into the DTO for submitting a ticket */
export async function transformSportBetSlipToTicket(betSlip: Omit<IBetSlip, 'payout'>): Promise<SubmitTicket> {
    const items = await Promise.all(betSlip.selections.map((s) => transformSelectionToTicketItem(
        s, {
            isSystem: betSlip.type === BetSlipType.system,
        },
    )));
    const e: SubmitTicket = ({
        ticketOnline: betSlip.purchaseType,
        total: betSlip.stake,
        betType: 'prematch',
        combs: betSlip.type === BetSlipType.system ? transformBetslipSystemCombinations(betSlip) : '',
        items,
        clientSourceType: 'desktop',
        paymentBonusType: betSlip.paymentBonusType || 0,
        locale: getConfig().appLocale.locale,
        requestDetails: {
            ldAnonymousUserKey: ldAnonymousUserKey ?? '',
            deviceId: getDeviceId(),
            isDeviceIdTestFlagOnSubscribed: `${getIsDeviceIdEnabledSubscribed()}`,
            isDeviceIdTestFlagOnInitial: `${getIsDeviceIdEnabledInitial()}`,
        },
        geoLocation: betSlip.geoLocation ?? 'develop',
        deviceIdentifier: getDeviceId(),
    });
    if (betSlip.autoUpdateChanges) {
        e.autoAcceptChanges = '1';
    }
    if (betSlip.ticketUuid) {
        e.ticketUuid = betSlip.ticketUuid;
    }

    return e;
}
